import React, { useEffect, useState } from "react";
import { GoogleMap, useLoadScript, MarkerF } from "@react-google-maps/api";

interface MapLocationProps {
  address: string;
}

interface Coordinates {
  lat: number;
  lng: number;
}

const MapLocation: React.FC<MapLocationProps> = ({ address }) => {
  const [coordinates, setCoordinates] = useState<Coordinates | null>(null);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY as string,
  });

  useEffect(() => {
    if (isLoaded && address) {
      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ address }, (results, status) => {
        if (status === "OK" && results?.[0]?.geometry?.location) {
          const location = results[0].geometry.location;
          setCoordinates({
            lat: location.lat(),
            lng: location.lng(),
          });
        }
      });
    }
  }, [isLoaded, address]);

  const mapContainerStyle = {
    width: "100%",
    height: "400px",
    borderRadius: "8px",
  };

  const options = {
    disableDefaultUI: false,
    zoomControl: true,
    scrollwheel: true,
    streetViewControl: true,
    mapTypeControl: true,
  };

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading...</div>;
  if (!coordinates) return <div>Loading map...</div>;

  return (
    <div>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={15}
        center={coordinates}
        options={options}
      >
        <MarkerF position={coordinates} title={address} />
      </GoogleMap>
    </div>
  );
};

export default MapLocation;
